import { ProgressDocument } from "@cs/lib/models/progress.model";
import { ProgressContext } from "@cs/screens/courses/progress/progress.context";
import { useContext } from "react";

export type CourseType = 'Basics' | 'Details'

export function useCourseGeneralProgress(
  courseId: string, 
  chapNum: number,
): number {
  const {progress} = useContext(ProgressContext)

  const count = (Object.keys(progress) as Array<keyof ProgressDocument>)
    .filter(chapKey => chapKey.startsWith(courseId) && progress[chapKey]?.state?.done).length
  return count/chapNum * 100
}

export function useCourseProgress(
  courseId: string, 
  chapNum: number,
  difficulty: CourseType
):number {
  const {progress} = useContext(ProgressContext)
  const count = (Object.keys(progress) as Array<keyof ProgressDocument>)
    .filter(chapKey => (
      chapKey.startsWith(courseId)
      && chapKey.includes(difficulty)
      && progress[chapKey]?.state?.done
    )).length

  return count / chapNum * 100
}